// extracted by mini-css-extract-plugin
export default {"fullHeight":"styles_fullHeight__U+uou"};